<template>
  <div
    class="accordion accordion-solid accordion-toggle-plus"
    id="accordion-form-conf"
  >
    <div class="card m-3">
      <div class="card-header">
        <div
          class="card-title collapsed py-3 pr-10 font-weight-normal"
          data-toggle="collapse"
          data-target="#collapse_conf"
        >
          <span>
            {{ $tc("ADVANCED_SETTINGS.DOMAIN.CONFIG_CONF.TITLE") }}
          </span>
        </div>
      </div>

      <div
        id="collapse_conf"
        class="collapse"
        data-parent="#accordion-form-conf"
      >
        <div class="card-body">
          <div class="d-flex flex-row justify-content-between">
            <div
              v-if="hasAccess('toRedirectHomepageToUniqueProgram', 'read')"
              class="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center mb-3"
            >
              <label class="mr-2 mb-0">{{
                $tc("ADVANCED_SETTINGS.DOMAIN.CONFIG_CONF.LABEL_REDIRECT_ALONE")
              }}</label>

              <div class="d-flex flex-column">
                <b-form-checkbox
                  v-model="form.toRedirectHomepageToUniqueProgram"
                  size="lg"
                  name="check-button"
                  switch
                  :disabled="
                    !hasAccess('toRedirectHomepageToUniqueProgram', 'write')
                  "
                />
              </div>
            </div>

            <div
              v-if="hasAccess('advertiser', 'read')"
              class="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center mb-3"
            >
              <label class="mr-2 mb-0">{{
                $tc("ADVANCED_SETTINGS.DOMAIN.CONFIG_CONF.LABEL_ADVERTISER")
              }}</label>

              <div class="d-flex flex-column">
                <b-form-checkbox
                  v-model="form.advertiser"
                  size="lg"
                  name="check-button"
                  switch
                  :disabled="!hasAccess('advertiser', 'write')"
                />
              </div>
            </div>
          </div>

          <div
            v-if="hasAccess('redirectTo', 'read')"
            class="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center mb-3"
          >
            <label class="mr-2 w-25">{{
              $tc("ADVANCED_SETTINGS.DOMAIN.CONFIG_CONF.LABEL_REDIRECT_TO")
            }}</label>

            <div class="d-flex flex-column w-75">
              <b-form-input
                v-model="form.redirectTo"
                :placeholder="
                  $tc('ADVANCED_SETTINGS.DOMAIN.CONFIG_CONF.LABEL_REDIRECT_TO')
                "
                class="form-control--grey"
                :disabled="!hasAccess('redirectTo', 'write')"
              />
            </div>
          </div>

          <div
            v-if="hasAccess('defaultLocale', 'read')"
            class="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center mb-3"
          >
            <label class="mr-2 w-25">{{
              $tc("ADVANCED_SETTINGS.DOMAIN.CONFIG_CONF.LABEL_DEFAULT_LOCALE")
            }}</label>

            <div class="d-flex flex-column w-75">
              <b-form-input
                v-model="form.defaultLocale"
                :placeholder="
                  $tc(
                    'ADVANCED_SETTINGS.DOMAIN.CONFIG_CONF.LABEL_DEFAULT_LOCALE'
                  )
                "
                class="form-control--grey"
                :disabled="!hasAccess('defaultLocale', 'write')"
              />
            </div>
          </div>

          <div
            v-if="hasAccess('organizationName', 'read')"
            class="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center mb-3"
          >
            <label class="mr-2 w-25">{{
              $tc(
                "ADVANCED_SETTINGS.DOMAIN.CONFIG_CONF.LABEL_ORGANIZATION_NAME"
              )
            }}</label>

            <div class="d-flex flex-column w-75">
              <b-form-input
                v-model="form.organizationName"
                :placeholder="
                  $tc(
                    'ADVANCED_SETTINGS.DOMAIN.CONFIG_CONF.LABEL_ORGANIZATION_NAME'
                  )
                "
                class="form-control--grey"
                :disabled="!hasAccess('organizationName', 'write')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAttributesRead, hasAttributeAccess } from "@/common/config/acl";
import auth from "@/store/auth.module";
import { FORM_CONF } from "@/common/config/acl/domain/conf";

export default {
  props: {
    domainId: {
      type: String,
      required: false
    },
    formProps: {
      type: Object,
      required: false
    }
  },

  data() {
    return {
      user: auth.state.user,
      form: getAttributesRead(FORM_CONF, auth.state.user.roles)
    };
  },

  mounted() {
    if (this.domainId) {
      this.form = this.formProps;
    }
  },

  methods: {
    hasAccess(field, accessType) {
      return hasAttributeAccess(FORM_CONF, this.user.roles, field, accessType);
    },
    resetData() {
      this.form = getAttributesRead(FORM_CONF, this.user.roles);
    }
  }
};
</script>
